export default __webpack_public_path__ + "static/media/stem-fill-arrow.9925e82d.svg";